import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { CommonConstants } from '@coreConstant';

@Directive({
  selector: '[appHandleImageError]',
  standalone: true
})
export class HandleImageErrorDirective {

  @Input() fallbackImage: string = CommonConstants.NO_IMAGE_PRODUCT;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('error') onError(): void {
    const imgElement = this.el.nativeElement as HTMLImageElement;
    this.renderer.setAttribute(imgElement, 'src', this.fallbackImage);
  }
}
